import { StoreTemplate } from "@/templates/TemplateLoader";
import { ReactNode } from "react";
import SectionContent from "@/templates/black-and-white/elements/SectionContent";
import PageHeader from "@/templates/black-and-white/elements/PageHeader";

const elements = {
  SectionContent,
  PageHeader,
};

export function SharedElementsLoader(props: { children: ReactNode }) {
  StoreTemplate.load("black-and-white", "shared", elements);
  return props.children;
}
